import * as React from "react";
import type { SVGProps } from "react";
const BedAndBreakfast = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4355_5410)">
      <path
        fill="currentColor"
        d="M13.3333 2.6664c0-.4125-.1875-.8-.5125-1.05s-.7458-.3417-1.1458-.2417l-7.4958 1.875c-.8875.2208-1.5125 1.0208-1.5125 1.9375v14.8125H1.3333A1.332 1.332 0 0 0 0 21.333a1.332 1.332 0 0 0 1.3333 1.3334h12zm-2.6666 9.3333c0 .7375-.4459 1.3333-1 1.3333s-1-.5958-1-1.3333.4458-1.3333 1-1.3333 1 .5958 1 1.3333m4-5.3333h4V21.333A1.332 1.332 0 0 0 20 22.6664h2.6667A1.332 1.332 0 0 0 24 21.333a1.332 1.332 0 0 0-1.3333-1.3333h-1.3334V6.6664c0-1.4709-1.1958-2.6667-2.6666-2.6667h-4z"
      />
    </g>
    <defs>
      <clipPath id="clip0_4355_5410">
        <path fill="transparent" d="M0 1.333h24v21.3333H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default BedAndBreakfast;
